/**
 * Client-side sign-in link copy logging (info/warn — visible at default LOG_LEVEL).
 */
import logger from '@/lib/logging';
import { SIGN_IN_LINK_COPY_LOG_PREFIX } from '@/lib/sign-in-link-copy-constants';

export { SIGN_IN_LINK_COPY_LOG_PREFIX };

export function logSignInLinkCopyInfo(
  event: string,
  data?: Record<string, unknown>
): void {
  logger.info(`${SIGN_IN_LINK_COPY_LOG_PREFIX} ${event}`, data ?? {});
}

export function logSignInLinkCopyWarn(
  event: string,
  data?: Record<string, unknown>
): void {
  logger.warn(`${SIGN_IN_LINK_COPY_LOG_PREFIX} ${event}`, data ?? {});
}
